import { ERRORS_MESSAGE } from "@lhd/constants";
import { APP_PART_TYPES } from "@lhd/features/Apps/AppForm/constants";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Checkbox, Form, Input, Select } from "antd";
import { FC, useContext, useMemo } from "react";
import { FormActionContext } from "@lhd/features/Apps/AppForm";

type PropsType = {
  getFieldClassName?: (name: string) => string;
  appPart?: AppPartType;
};

const EmployeeSignatureSetting: FC<PropsType> = ({
  getFieldClassName,
  appPart,
}) => {
  const { contextState } = useContext(FormActionContext);

  const workerSelectionOptions = useMemo(() => {
    const list: { label: string; value: string }[] = [];
    (contextState?.layout || []).forEach((part: AppPartType) => {
      if (
        part.app_part_type === APP_PART_TYPES.WORKER_SELECTION &&
        part.item_config_data?.i !== appPart?.item_config_data?.i &&
        part.field_code
      ) {
        list.push({
          label: part.name || part.field_code,
          value: part.field_code,
        });
      }
      if (part.children && Array.isArray(part.children)) {
        part.children.forEach((child: AppPartType) => {
          if (
            child.app_part_type === APP_PART_TYPES.WORKER_SELECTION &&
            child.item_config_data?.i !== appPart?.item_config_data?.i &&
            child.field_code
          ) {
            list.push({
              label: `${part.name || part.field_code} > ${
                child.name || child.field_code
              }`,
              value: child.field_code,
            });
          }
        });
      }
    });
    return list;
  }, [contextState?.layout, appPart?.item_config_data?.i]);

  return (
    <>
      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item
        label="関連する社員選択"
        name="referenced_field_code"
        rules={[{ required: true, message: "社員選択を選択してください" }]}
        className={`${getFieldClassName?.("referenced_field_code")}`}
      >
        <Select
          allowClear
          placeholder="社員選択フィールドを選択してください"
          options={workerSelectionOptions}
        />
      </Form.Item>
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default EmployeeSignatureSetting;
